<template>
  <main class="tos-screen">
    <v-content>
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex xs8 offset-xs2>
            <h1 class="text--white">Termos de Declaração</h1>
            <v-textarea
              v-model="tos"
              readonly
              hide-details
              class="tos-text-field"
            ></v-textarea>
            <v-layout row wrap>
              <v-flex xs8>
                <v-checkbox
                  v-model="model.acceptedTos"
                  label="Declaro que li e estou ciente das condições acima"
                  color="white"
                  dark
                ></v-checkbox>
              </v-flex>
              <v-flex xs4>
                <button
                  class="button yellow-button jns-button"
                  :disabled="!model.acceptedTos || !scrolledToBottom"
                  @click="acceptTos"
                >
                  Concluir
                </button>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<style lang="scss" scoped>
#jns {
  .text--white {
    color: #fff;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .tos-text-field {
    height: 70vh !important;
    max-height: 70vh !important;
    padding: 0;
    background-color: white;

    .input-group__details {
      display: none;
    }
    textarea,
    .v-text-field__slot {
      height: 70vh !important;
    }

    textarea {
      padding: 2vh !important;
    }
  }
  .tos-text {
    margin-top: 20px;
    display: inline-block;
  }
}
</style>

<script lang="js">
import axios from "axios";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "TermosDeServico",
  mixins: [ViewMixin],
  data: () => ({
    formErrors: [],
    model: {
      acceptedTos: false,
    },

    tos: false,

    selecionarEmpresaDialog: false,
    recuperarSenhaDialog: false,
    companies: false,
    scrolledToBottom: false,
  }),
  methods: {
    async acceptTos() {
      let response;
      let t = this;
      if (t.model.acceptedTos) {
        t.forceAcceptTos();
      }
      try {
        response = await t.$store.dispatch("ACCEPT_TOS", {
          termos_de_uso: true,
        });
      } catch (e) {
        console.warn(e);
      }
      if (response) {
        t.$router.push({ name: "Início" });
      }
    },
    textareaAtEnd(area) {
      if (
        area.target.scrollTop + area.target.offsetHeight >=
        area.target.scrollHeight
      ) {
        this.scrolledToBottom = true;
      }
    },
    forceAcceptTos() {},
  },
  mounted() {
    let t = this;
    t.alertText = t.handleAlertText();
    t.tos = t.$strings.tos;
    document
      .querySelector("textarea")
      .addEventListener("scroll", t.textareaAtEnd);
  },
};
</script>



// WEBPACK FOOTER //
// ./src/router/views/TermosDeServico.vue